export const BANK_ACCOUNT_LIMIT = 2;
export const ENTERPRISE_BANK_ACCOUNT_LIMIT = 2;
